export const drawerHeader = (theme) => ({
    drawerHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: `1px solid ${theme.customPalette.neutralGy05}`,
        padding: "24px 21px",
        [theme.breakpoints.down("xs")]: {
            borderTop: `27px solid ${theme.customPalette.neutralGy05}`,
        },
    },
    title: {
        lineHeight: 1.29,
    },
    closeButton: {
        height: "fit-content",
        width: "fit-content",
    },
    icon: {
        width: 20,
        height: 20,
    },
});

export const drawer = (theme, drawerWidth) => ({
    drawer: {
        position: "absolute",
        zIndex: "1400",
        width: drawerWidth,
        flexShrink: 0,
        [theme.breakpoints.down("xs")]: {
            width: "100%",
        },
    },
    drawerPaper: {
        width: drawerWidth,
        [theme.breakpoints.down("xs")]: {
            width: "100%",
        },
    },
    drawerContent: {
        padding: theme.spacing(3),
        paddingTop: "0",
        height: "100%",
        overflowY: "auto",
        "& div:first-child": {
            border: "none",
        },
        [theme.breakpoints.up("sm")]: {
            paddingTop: "auto",
        },
    },
});
